import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Typography, DialogActions } from "@material-ui/core";
import CustomButton from "../../CustomButton/CustomButton";
import { DELETE_ITEM_DIALOG } from "../../../data/StringConstants";
export default function DeleteItemConfirmationDialogContent({ onClickCancel, onClickConfirm, disableDeleteButton }) {
	return (
		<Fragment>
			<Typography variant="caption">{DELETE_ITEM_DIALOG.BODY}</Typography>
			<DialogActions>
				<CustomButton onClick={onClickCancel}>
					{DELETE_ITEM_DIALOG.CANCEL_BTN}
				</CustomButton>
				<CustomButton
					color="error"
					variant="contained"
					onClick={onClickConfirm}
					disabled={disableDeleteButton}
				>
					{DELETE_ITEM_DIALOG.DELETE_BTN}
				</CustomButton>
			</DialogActions>
		</Fragment>
	);
}

DeleteItemConfirmationDialogContent.propTypes = {
	onClickCancel: PropTypes.func.isRequired,
	onClickConfirm: PropTypes.func.isRequired,
	disableDeleteButton: PropTypes.bool.isRequired,
};
